import { render, staticRenderFns } from "./ClickAndBuysStruct.vue?vue&type=template&id=613a9998&scoped=true"
import script from "./ClickAndBuysStruct.vue?vue&type=script&lang=js"
export * from "./ClickAndBuysStruct.vue?vue&type=script&lang=js"
import style0 from "./ClickAndBuysStruct.vue?vue&type=style&index=0&id=613a9998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613a9998",
  null
  
)

export default component.exports